import { Component, OnInit } from '@angular/core';
//import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
//import { AssessmentService } from "../../services/assessment.service";
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { CourseService } from '../../services/course.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-course-add-review',
  templateUrl: './course-add-review.component.html',
  styleUrls: ['./course-add-review.component.scss']
})
export class CourseAddReviewComponent implements OnInit {
  showDetails: boolean = false;
  activeCourse: boolean = true;
  succesCourse: boolean = false;
  panelOpenState = false; adminData: any;
  activeTab = 0; courseId: any = ''; tab: any = ''; courseData: any; type: any = '';
  constructor(private route: ActivatedRoute,
    private router: Router,
    private contentAuthoringApi: ContentAuthoringService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal, private toastr: ToastrService, private authCourse: CourseService) { }
  successClick() {
    this.succesCourse = true;
    this.activeCourse = false;
  }
  showDetailsEvent() {
    this.showDetails = !this.showDetails;
  }
  /*******save as draft course */
  SaveDraft() {
    this.router.navigate(['/courses'], { queryParams: { tab: 2 } });
  }
  /*****get couse detail ****/
  getCourseAuthDetails(courseId: any) {
    this.authCourse.CourseDetail(courseId).subscribe(
      data => {
        console.log(data,'sdsdsdgfg');
        this.courseData = data.courseData
      }, error => {

      }
    )
  }
  coursePublised(course_id: any) {
    if (!this.type) {
      this.authCourse.CoursePublish(course_id).subscribe(
        (data) => {
          if (data.status == 200) {
            this.router.navigate(['/courses_published'], { queryParams: { courseId: this.courseId, key: 'publish' } });
          } else { }
        },
        (error) => { },
      );
    } else {
      this.router.navigate(['/courses']);
    }
    document.getElementById('closelId')?.click();

  }
  cancelbkModule() {
    if (!this.type) {
      this.router.navigate(['./courses_add_modules'], { queryParams: { courseId: this.courseId,pro: 'review' } });
    } else {
      this.router.navigate(['./courses_add_modules'], { queryParams: { courseId: this.courseId, type: 'edit' } });
    }
    document.getElementById('CloseIds')?.click();

  }
  cancelCourse() {
    if(!this.type){
      this.authCourse.deletesCourse(this.courseId).subscribe(
        (data) => {
          if (data.status == 200) {
            document.getElementById('CloseIds')?.click();
            this.router.navigate(['/courses']);
          }
        },
        (error) => { },
      );
    }else{
      document.getElementById('CloseIds')?.click();
      this.router.navigate(['/courses']);
    }
   
  }
  getMediaType(mediatypeArr: any, media_type: any) {
    const checkMediType = (obj: { media_type: string; }) => obj.media_type == media_type;
    return mediatypeArr.some(checkMediType);
  }
  closeResult = '';
  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm' });
  }
  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.courseId = queryParams['courseId'];
      this.tab = queryParams['tab'];
      this.type = queryParams['type'];
    });
    if (this.courseId != '' && this.courseId != null) {
      this.getCourseAuthDetails(this.courseId);
    }
  }
  logout() {
   // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
}
